/**
 * iter87.360 (user-reported) — Box Score / Highlights / venue links use
 * target="_blank" or window.open(), which iOS/Android standalone PWAs
 * ("Add to Home Screen") silently swallow — there's no browser chrome to
 * open a new tab into, so the tap does nothing. Detect standalone display
 * mode and fall back to a same-window navigation, which always works.
 */
export function isStandalonePwa() {
    if (typeof window === "undefined") return false;
    return Boolean(
        window.matchMedia?.("(display-mode: standalone)").matches
        || window.navigator?.standalone === true,
    );
}

export function openExternalLink(url) {
    if (!url) return;
    if (isStandalonePwa()) {
        window.location.href = url;
    } else {
        window.open(url, "_blank", "noopener,noreferrer");
    }
}
